import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Subscription, timer } from 'rxjs';

const stopWaiting = 30000; // in milliseconds

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() public showRetry = false;
  @Input() public showLoader = false;
  @Input() public isInner = false;
  @Input() public isOverlay = false;
  @Input() public small = false;
  @Input() public containerHeight: string;
  @Input() public retryCb: Function;
  @Input() class: string;

  public stopWaiting = false;

  private _subs: Subscription;

  constructor(
    private _cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.stopWaiting = false;

    this._subs = timer(stopWaiting).subscribe(() => {
      this.stopWaiting = true;
      this._cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this._subs) {
      this._subs.unsubscribe();
    }
  }
}
